var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 d-flex flex-column align-items-center justify-content-center"},[_c(_vm.type,{tag:"component"}),_c('h1',{staticClass:"fs-20 fw-b mt-30 mb-30"},[_vm._t("title")],2),_c('p',{staticClass:"fs-15 mb-0 d-flex flex-column text-center"},[_vm._t("description")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }